export default __webpack_public_path__ + "media/color/gno-6e30a4fe.svg";